(() => {
  const root = document.querySelector('[data-room-section]');
  if (!root) return;
  const sectionId = root.dataset.roomSection;
  const grid = root.querySelector('.nanref-room__grid');
  const results = root.querySelector('.nanref-room__results');
  const progress = root.querySelector('.nanref-room__progress');
  const base = root.dataset.collectionUrl;
  let busy = false;
  const filterOpen = root.querySelector('.nanref-room__filter-open');
  const filterDrawer = root.querySelector('.nanref-room__filter-drawer');
  if (filterOpen && filterDrawer) {
    filterOpen.addEventListener('click', () => filterDrawer.showModal());
    filterDrawer.addEventListener('close', () => filterOpen.focus());
  }

  // Shopify can omit hidden input values when rendering filter forms. The URL is
  // the source of truth for the current storefront filter and sort state.
  const currentParams = new URL(location.href).searchParams;
  for (const form of root.querySelectorAll('.nanref-room__toolbar form')) {
    const used = new Map();
    for (const input of form.querySelectorAll('input[type="hidden"]')) {
      const index = used.get(input.name) || 0;
      input.value = currentParams.getAll(input.name)[index] || '';
      used.set(input.name, index + 1);
    }
    if (currentParams.has('view')) {
      const view = document.createElement('input');
      view.type = 'hidden';
      view.name = 'view';
      view.value = currentParams.get('view');
      form.append(view);
    }
  }
  if (!grid || !results || !progress) return;

  async function loadSection(url) {
    const request = new URL(url, location.origin);
    request.searchParams.set('section_id', sectionId);
    const response = await fetch(request, {credentials: 'same-origin'});
    if (!response.ok) throw new Error('Page could not be loaded');
    const document = new DOMParser().parseFromString(await response.text(), 'text/html');
    const next = document.querySelector(`[data-room-section="${sectionId}"]`);
    if (!next) throw new Error('Collection page is unavailable');
    return next;
  }

  function update(next, count) {
    const nextResults = next.querySelector('.nanref-room__results');
    results.dataset.page = nextResults.dataset.page;
    results.dataset.next = nextResults.dataset.next;
    results.dataset.total = nextResults.dataset.total;
    progress.querySelector('[data-shown]').textContent = count;
    progress.querySelector('[data-total]').textContent = nextResults.dataset.total;
    const bar = progress.querySelector('[role="progressbar"]');
    bar.setAttribute('aria-valuenow', count);
    bar.setAttribute('aria-valuemax', nextResults.dataset.total);
    bar.querySelector('span').style.width = `${Math.min(100, count / Number(nextResults.dataset.total) * 100)}%`;
    const old = progress.querySelector('.nanref-room__load');
    if (old) old.remove();
    const nextLink = nextResults.querySelector('.nanref-room__load');
    if (nextLink) progress.append(nextLink.cloneNode(true));
  }

  async function restore(page) {
    if (busy) return;
    busy = true;
    try {
      const search = new URL(location.href).searchParams;
      grid.replaceChildren();
      let last;
      for (let n = 1; n <= page; n++) {
        const url = new URL(base, location.origin);
        for (const [key, value] of search) if (key !== 'page') url.searchParams.append(key, value);
        if (n > 1) url.searchParams.set('page', n);
        last = await loadSection(url);
        const cards = last.querySelectorAll('.nanref-room__grid > li');
        for (const card of cards) grid.append(card.cloneNode(true));
      }
      update(last, grid.querySelectorAll('.nanref-room-card').length);
    } catch (error) { location.reload(); }
    finally { busy = false; }
  }

  root.addEventListener('click', async event => {
    const link = event.target.closest('.nanref-room__load');
    if (!link || !root.contains(link) || busy) return;
    event.preventDefault();
    busy = true;
    link.setAttribute('aria-busy', 'true');
    try {
      const next = await loadSection(link.href);
      const cards = next.querySelectorAll('.nanref-room__grid > .nanref-room-card');
      const seen = new Set([...grid.querySelectorAll('.nanref-room-card')].map(card => card.dataset.productId));
      for (const card of cards) if (!seen.has(card.dataset.productId)) grid.append(card.cloneNode(true));
      update(next, grid.querySelectorAll('.nanref-room-card').length);
      history.pushState({roomPage: Number(results.dataset.page)}, '', link.href);
    } catch (error) { link.textContent = 'Try loading again'; link.removeAttribute('aria-busy'); }
    finally { busy = false; }
  });
  addEventListener('popstate', () => restore(Number(new URL(location.href).searchParams.get('page') || 1)));
  const initialPage = Number(new URL(location.href).searchParams.get('page') || 1);
  if (initialPage > 1) restore(initialPage);
})();

// Subcategory chips (client-side, works without the Search & Discovery filter index)
(() => {
  const nav = document.querySelector('[data-sub-chips]');
  if (!nav) return;
  const root = nav.closest('[data-room-section]');
  const grid = root.querySelector('.nanref-room__grid');
  const count = root.querySelector('.nanref-room__toolbar-count');
  const shown = root.querySelector('.nanref-room__progress [data-shown]');
  const total = root.querySelector('.nanref-room__progress [data-total]');
  const guide = root.querySelector('.nanref-room__guide');
  const chips = [...nav.querySelectorAll('a[data-sub]')];
  const apply = (value) => {
    let n = 0;
    for (const card of grid.querySelectorAll('.nanref-room-card')) {
      const match = !value || card.dataset.sub === value;
      card.hidden = !match;
      if (match) n++;
    }
    if (guide) guide.hidden = Boolean(value) && value !== 'Magnetic labels';
    for (const chip of chips) {
      if (chip.dataset.sub === value) chip.setAttribute('aria-current', 'page');
      else chip.removeAttribute('aria-current');
    }
    if (count) count.textContent = `${n} products`;
    if (shown) shown.textContent = n;
    if (total) total.textContent = n;
    const url = new URL(location.href);
    if (value) url.searchParams.set('sub', value); else url.searchParams.delete('sub');
    history.replaceState(history.state, '', url);
    const active = chips.find(chip => chip.dataset.sub === value);
    if (active) nav.scrollLeft = Math.max(0, active.offsetLeft - 16);
  };
  nav.addEventListener('click', event => {
    const chip = event.target.closest('a[data-sub]');
    if (!chip) return;
    event.preventDefault();
    apply(chip.dataset.sub);
  });
  root.addEventListener('click', event => {
    const link = event.target.closest('.nanref-room__guide a[href*="sub="]');
    if (!link) return;
    event.preventDefault();
    apply('Magnetic labels');
    nav.scrollIntoView({block: 'start', behavior: 'smooth'});
  });
  const initial = new URL(location.href).searchParams.get('sub');
  if (initial && chips.some(chip => chip.dataset.sub === initial)) apply(initial);
})();

// Keep the current sibling chip visible on sub-category pages
(() => {
  const current = document.querySelector('.nanref-room__chips:not([data-sub-chips]) a[aria-current]');
  if (current) current.parentElement.scrollLeft = current.offsetLeft - 16;
})();
